import { useMemo as u, useRef as x } from "react";
import { i as A } from "../useResizeDetector-sfyDtky2.js";
import { l as e } from "../lodash-DeBCDn4U.js";
import { l as k } from "../utils-wNl4DVdv.js";
function D(n, s) {
  const i = u(n, s), t = x();
  return A.isEqual(i, t.current) || (t.current = i), t.current;
}
const E = (n, s) => n.listDimensions().filter((i) => !s.find((t) => !n.checkDimensionInView(i, t))), y = (n, s, i = [], t) => {
  const f = D(
    () => {
      const r = s ? n.getView(s) : void 0;
      return s ? r ? [r] : [] : n.listViews().filter((g) => (i == null ? void 0 : i.length) === 0 || i && k(i).every(
        (v) => n.checkDimensionInView(v.dimensionCode, g)
      ));
    },
    [s, n, i]
  ), m = D(
    () => s ? [] : n.listViews().filter((r) => !f.find((o) => (o == null ? void 0 : o.code) === r.code)),
    [s, n, f]
  ), c = D(
    () => s ? [s] : e.uniq(t == null ? void 0 : t.map(({ viewCode: r }) => r)),
    [s, t]
  ), p = u(
    () => E(n, c),
    [n, c]
  ), h = u(
    () => n.listDimensions().filter((r) => !p.find((o) => o.code === r.code)),
    [n, p]
  );
  return {
    availableViews: f,
    unavailableViews: m,
    requiredViewsCode: c,
    availableDimensions: p,
    unavailableDimensions: h
  };
};
export {
  E as getAvailableDimensions,
  y as useRequirements
};
//# sourceMappingURL=useRequirements.js.map
